import { useState, useEffect, useRef } from 'react';
import { API_BASE_URL } from '../../config';
import { EventEmitter } from '../../utils/eventEmitter';

// Create a shared event emitter instance
export const notificationEmitter = new EventEmitter();

export const useUserUnreadNotifications = (token) => {
    const timerIdRef = useRef(null);
    const [isPollingEnabled, setIsPollingEnabled] = useState(true);
    const [unreaded, setUnreaded] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchUserNotifications = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/notifications/unread`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            const numberOfUnreadNotifications = data?.unread || 0;
            setUnreaded(numberOfUnreadNotifications);
        } catch (err) {
            setError(err);
            setUnreaded(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

        const startPolling = () => {
            fetchUserNotifications(); // To immediately start fetching data
            // Polling every 30 seconds
            timerIdRef.current = setInterval(fetchUserNotifications, 30000);
        };

        const stopPolling = () => {
            clearInterval(timerIdRef.current);
        };

        // Listen for the force-refresh event to fetch data immediately
        const handleForceRefresh = () => {
            fetchUserNotifications();
        };

        if (token && isPollingEnabled) {
            startPolling();
        } else {
            stopPolling();
        }

        // Set up the event listener for force-refresh
        notificationEmitter.on('force-refresh', handleForceRefresh);

        return () => {
            stopPolling();
            notificationEmitter.off('force-refresh', handleForceRefresh); // Remove event listener
        };
    }, [token, isPollingEnabled]);

    return { unreaded, loading, error };
};